import { Tag } from '../../Context/dist/effect-Context.esm.js';
import { fiberRefUnsafeMake, fiberRefGet, fiberRefLocally } from '../../internal/core.esm.js';

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */
const TestSizedTypeId = /*#__PURE__*/Symbol.for("effect/TestSized");

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */
const TestSized = /*#__PURE__*/Tag(TestSizedTypeId);

/** @internal */
class SizedImpl {
  [TestSizedTypeId] = TestSizedTypeId;
  constructor(fiberRef) {
    this.fiberRef = fiberRef;
  }
  size() {
    return fiberRefGet(this.fiberRef);
  }
  withSize(size) {
    return effect => fiberRefLocally(this.fiberRef, size)(effect);
  }
}

/**
 * @since 2.0.0
 */
const make = size => new SizedImpl(fiberRefUnsafeMake(size));

/**
 * @since 2.0.0
 */
const fromFiberRef = fiberRef => new SizedImpl(fiberRef);

export { TestSized, TestSizedTypeId, fromFiberRef, make };
